import React from 'react';

const Hero = () => {
  return (
    <section className="hero is-primary is-large">
      <div className="hero-body">
        <div className="container has-text-centered">
          <figure className="image is-inline-block mb-5 mx-auto is-128x128">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="AZCOREMSH.NET Logo" />
          </figure>
          <h1 className="title is-1 is-spaced has-text-white">
            AZCOREMSH.NET
          </h1>
          <h2 className="subtitle is-3 has-text-white">
            Building Arizona's Decentralized Mesh Network
          </h2>
          <div className="buttons is-centered mt-6">
            <a href="#about" className="button is-white is-medium is-outlined">
              <span>Learn More</span>
            </a>
            <a href="/map" className="button is-white is-medium">
              <span>View Map</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
